<template>
  <router-link
    v-if="has_props"
    :to="get_props"
    :class="default_button ? 'default-button button_small' : ''">
    <slot></slot>
  </router-link>
  <a href="#" v-else>
    <slot></slot>
  </a>
</template>

<script>
export default {
  name: "RouterLinkTo",
  props: {
    route_name: {
      type: String,
      default: ''
    },
    route_params: {
      type: Object,
      default: null
    },
    href: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    default_button: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    has_props() {
      return this.route_name || this.href
    },
    get_props() {
      if (this.route_name) {
        let data = {}
        data['name'] = this.route_name
        if (this.route_params) {
          data['params'] = this.route_params
        }
        return data
      }
      if (this.href) {
        return {
          path: this.href
        }
      }
      return {}
    }
  }
}
</script>
